import Skeleton from 'react-loading-skeleton'
import styled from 'styled-components'

export const HomeFeedSkeleton = () => {
    return (
        <SkeletonWrapper>
            <div className='skeleton'>
                <Skeleton borderRadius={20} height={370} />
                <Skeleton
                    style={{ marginTop: 10 }}
                    borderRadius={20}
                    height={50}
                />
            </div>
            <div className='skeleton'>
                <Skeleton borderRadius={20} height={370} />
                <Skeleton
                    style={{ marginTop: 10 }}
                    borderRadius={20}
                    height={50}
                />
            </div>
            <div className='skeleton'>
                <Skeleton borderRadius={20} height={370} />
                <Skeleton
                    style={{ marginTop: 10 }}
                    borderRadius={20}
                    height={50}
                />
            </div>
        </SkeletonWrapper>
    )
}

const SkeletonWrapper = styled.div`
    & > * + * {
        margin-top: 1.25rem;
    }
`
